import axios from 'axios';

const staticTaskApi = {
  async getStaticTasks() {
    const response = await axios.get('/api/statictask');
    return response.data;
  },
  async getStaticTask(id) {
    const response = await axios.get(`/api/statictask/${id}`);
    return response.data;
  },
  async createStaticTask(staticTask) {
    const response = await axios.post('/api/statictask', staticTask);
    return response.data;
  },
  async updateStaticTask(staticTask) {
    const response = await axios.put(`/api/statictask/${staticTask.id}`, staticTask);
    return response.data;
  },
  async deleteStaticTask(id) {
    const response = await axios.delete(`/api/statictask/${id}`);
    return response.data;
  }

};

export default staticTaskApi;
